<template>
    <div>
        <app-button-scroll-to-top />
        <b-row>
            <b-col>
                <app-sub-title text="Filtros"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-form-select-input
                    placeholder="Año"
                    :options="years"
                    v-model="year"
                />
            </b-col>
            <b-col>
                <app-form-select-input
                    placeholder="Periodo"
                    :options="months"
                    v-model="month"
                />
            </b-col>
            <b-col class="right-spaced">
                <b-btn
                    variant="primary"
                    @click="loadSupervisorBonus"
                    :disabled="!validPeriod || inProgress"
                    ><i class="fa fa-filter"></i
                ></b-btn>
                <!-- <b-btn variant="success" :disabled="!validPeriod || inProgress"
                    ><i class="fa fa-download"></i
                ></b-btn> -->
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-supervisor-bonus-resume
                    :users="goalBonuses"
                    @scroll-to="onScrollTo"
                ></app-supervisor-bonus-resume>
            </b-col>
        </b-row>
        <b-row class="mt-5">
            <b-col>
                <app-supervisor-bonus-table
                    :bonuses="goalBonuses"
                ></app-supervisor-bonus-table>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import appSupervisorBonusTable from './SupervisorBonusTable'
import appSupervisorBonusResume from './SupervisorBonusResume'
import appButtonScrollToTop from '@components/UI/Controls/ButtonScrollToTop/ButtonScrollToTop'
export default {
    components: {
        appSupervisorBonusTable,
        appSupervisorBonusResume,
        appButtonScrollToTop,
    },
    data: () => ({
        year: '',
        month: '',
        goalBonuses: [],
    }),
    computed: {
        ...mapGetters(['years', 'months']),
        validPeriod() {
            return !!this.year && !!this.month
        },
        period() {
            return this.validPeriod
                ? `${this.year}${_.padStart(this.month, 2, '0')}`
                : null
        },
    },
    methods: {
        async loadSupervisorBonus() {
            const { data } = await repo.get('supervisor-goal-bonus', {
                period: this.period,
            })

            this.goalBonuses = data.goalBonuses
            this.year = data.period.substr(0, 4)
            this.month = parseInt(data.period.substr(4, 2))
        },
        onScrollTo(tag) {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $(`#${tag}`).offset().top,
                },
                1000
            )
            // const x = $(`#${tag}`).position()
            // const top = x.top
            // window.scroll(0, top)
        },
    },
    mounted() {
        this.load('years')
        this.load('months')
        this.loadSupervisorBonus()
    },
}
</script>
